import { StyleProps, useViewStyleProps } from '@euler/components/layout/View';
import { forwardRef, memo } from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';

export type EulerTouchableOpacityProps = TouchableOpacityProps & StyleProps;

const EulerTouchableOpacity = memo(
  forwardRef<TouchableOpacity, EulerTouchableOpacityProps>((props, ref) => {
    const [style, viewProps] = useViewStyleProps(props as any);
    return <TouchableOpacity ref={ref} style={style} {...viewProps} />;
  }),
);

export default EulerTouchableOpacity;
